import { Link } from 'react-router-dom';
import { STORIES } from '../content/stories';

export function StoriesPage() {
  return (
    <section className="px-6 pt-28 pb-20 lg:px-10 lg:pt-36">
      <div className="mx-auto max-w-[860px]">
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/15 bg-brand-light px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
          How it is used
        </div>
        <h1 className="font-display mb-4 text-[2.75rem] leading-[1.06] font-extrabold text-ink lg:text-[3.375rem]">
          Walkthroughs, not invented logos.
        </h1>
        <p className="mb-12 max-w-[54ch] text-[1.0625rem] leading-[1.7] text-ink-2">
          These are the jobs cevop is built for. They are not named case studies or testimonials.
        </p>
        <div className="mk-stagger space-y-3">
          {STORIES.map((story) => (
            <Link
              key={story.slug}
              to={`/stories/${story.slug}`}
              className="mk-lift block rounded-2xl border border-line bg-panel p-6 shadow-sm hover:border-brand/30"
            >
              <div className="mb-2 text-[0.72rem] font-bold tracking-widest text-brand uppercase">{story.label}</div>
              <h2 className="font-display mb-2 text-[1.15rem] font-bold text-ink">{story.title}</h2>
              <p className="text-[0.88rem] leading-[1.65] text-ink-3">{story.summary}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
